import React, { useState, useContext } from 'react';
import { UserContext } from '../contexts/UserProvider';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const AccountSetup = () => {
  const { userAuth, createFirestoreUser } = useContext(UserContext);
  const [name, setName] = useState(userAuth.displayName);
  const [email, setEmail] = useState(userAuth.email);
  const [photoURL, setPhotoURL] = useState(userAuth.photoURL);

  const handleSubmit = async (event) => {
    event.preventDefault();
    await createFirestoreUser({ displayName: name, email, userPhoto: photoURL });
    // Further actions after account setup, like redirecting to main app
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh', 
      margin: 'auto'
    }}>
      <Box sx={{ maxWidth: 400, width: '100%', padding: '20px' }}>
          <Typography variant="subtitle2" display="block" gutterBottom style={{ lineHeight: "16px" }}>
            Consider changing your display name so others recognize you:
          </Typography>
          <form onSubmit={handleSubmit}>
              <TextField
                  label="Display Name"
                  variant="outlined"
                  fullWidth
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  margin="normal"
              />
              <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={email}
                  margin="normal"
                  type="email"
                  disabled={true}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2 }}>
                  <Avatar src={photoURL} sx={{ width: 100, height: 100 }} />
              </Box>
              <Button type="submit" variant="contained" color="primary" fullWidth>
                Set Up Account
              </Button>
          </form>
      </Box>
    </Box>
  );
};
